import React, { useContext, useEffect, useMemo } from 'react'
import { Typography, List, ListItem, ListItemIcon, Box } from '@mui/material'
import { LocationOnOutlined, KeyboardArrowRight } from '@mui/icons-material'
import { PATHS } from '../../constants'
import { EmploymentsContext } from '../../contexts/EmploymentsContext'
import PageWithTitleLayout from '../Layout/PageWithTitleLayout'
import { changeSelectedStore } from '../../Utilities/authenticationService'
import moment from 'moment'

const SelectStore = ({ history }) => {
    const {
        userEmployments: employments,
        isManagerFor = {},
        canEditShiftFor = {},
        isAdmin
    } = useContext(EmploymentsContext)

    // Prefer employment row flags so we don't race App's later isManagerFor/canEditShiftFor maps.
    const isManagerOrEditor = useMemo(() => {
        if (isAdmin) return true
        if (employments?.some(e => e.is_manager || e.can_edit_shift)) return true
        return Object.values(isManagerFor).some(Boolean) || Object.values(canEditShiftFor).some(Boolean)
    }, [employments, isManagerFor, canEditShiftFor, isAdmin])

    useEffect(() => {
        if (!employments?.length) return
        // Part-timers use a single person-level submit flow — skip store picking.
        if (isManagerOrEditor) return

        const selectedId = parseInt(localStorage.getItem('selected_emp'), 10)
        const primary = employments.find(e => e.id === selectedId) || employments[0]
        if (!primary) return

        const storedMonth = localStorage.getItem('frederickSelectedYearMonth')
        const month = storedMonth ? JSON.parse(storedMonth) : moment().format('YYYY-MM')
        const storeOpen = emp => !emp?.store?.closed_months?.includes(month)
        // Prefer primary when open; otherwise first open store (same as Home CTA).
        const target =
            (primary && storeOpen(primary) && primary) ||
            employments.find(storeOpen) ||
            primary

        changeSelectedStore(target.id)
        history.replace(
            PATHS.shiftManagement
                .replace(':employmentId', target.id)
                .replace(':calendarYearMonth', month)
                .replace(':tabValue', 'submit')
        )
    }, [employments, isManagerOrEditor, history])

    if (!isManagerOrEditor) {
        return null
    }

    return (
        <PageWithTitleLayout title="希望シフトを提出する">
            <Box className="shrinkable">
                <Typography variant="subtitle2" margin="1rem" marginTop=".5rem" marginBottom=".5rem">
                    希望シフトを提出する店舗を選択してください。店舗を選ぶと、その店舗の従業員の希望シフトを代理提出できます。
                </Typography>
                <List sx={{ mx: '1rem' }}>
                    {employments.map(e => {
                        return (
                            <ListItem
                                key={e.id}
                                onClick={() => {
                                    changeSelectedStore(e.id)
                                    history.push(PATHS.stores + e.id)
                                }}
                            >
                                <ListItemIcon>
                                    <LocationOnOutlined />
                                </ListItemIcon>
                                {e.store.name}
                                <KeyboardArrowRight sx={{ ml: 'auto' }} />
                            </ListItem>
                        )
                    })}
                </List>
            </Box>
        </PageWithTitleLayout>
    )
}

export default SelectStore
